<template>
    <v-textarea
        :id="id"
        v-model="modelValue"
        :variant="variant"
        :disabled="disabled"
        :maxlength="max"
        :minlength="min"
        :counter="counter"
        :rules="[rules.required, rules.max, rules.min]"
        :append-inner-icon="getAppendIcon"
        :color="isValid ? 'success' : undefined"
        @update:is-valid="emit('update:isValid', $event)"
    >
    </v-textarea>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ITextAreaField } from '../../types';
import { useValidation } from '../../composables';

const modelValue = defineModel<string>('modelValue');

const props = withDefaults(defineProps<ITextAreaField>(), {
    variant: 'outlined',
    disabled: false
});

const { rules, validateRules, getIconStatus } = useValidation(props);

const isValid = computed(() => validateRules(modelValue.value));

const getAppendIcon = computed(() => getIconStatus(modelValue.value, isValid.value));

const emit = defineEmits(['update:isValid']);
</script>
